import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface AddNewButtonProps extends Omit<ButtonProps, 'variant' | 'size' | 'startIcon'> {
  'data-cy'?: string;
}

const AddNewButton: React.FC<AddNewButtonProps> = ({ children = 'Add New', sx, ...props }) => {
  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<AddIcon />}
      sx={{
        fontSize: 12,
        px: 1.5,
        py: 0.5,
        minHeight: 28,
        height: 28,
        borderRadius: 2,
        borderColor: 'divider',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default AddNewButton;
